import {
  FETCH_FOOTER_REQUEST,
  FETCH_FOOTER_SUCCESS,
  FETCH_FOOTER_FAILURE,
} from "../action/contentAction";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const footerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FOOTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FOOTER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_FOOTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default footerReducer;
